export const base_fields_risk = new Set([
  'title',
  'description',
  'root_cause',
  'event',
  'category',
  'created_at',
  'updated_at',
  'key_risk_indicators'
]);

export const instance_fields_risk = new Set([
  'impact_consequence',
  'probability_of_occurrence',
  'severity',
  'speed_of_occurrence',
  'risk_assessment_score',
  'risk_trend',
  'gross_risk',
  'residual_risk',
  'risk_status',
  'assessment_date',
  'update_cycle',
  'start_date',
  'end_date',
  'owner_maintainer',
  'risk_owner'
]);

export const base_fields_control = new Set([
  'controlName',
  'controlDescription',
  'controlObjective',
  'controlType',
  'controlNature',
  'controlFrequency',
  'testingMethod',
  'startDate',
  'endDate',
  'controlOrigin',
  'controlCustodian'
]);

export const instance_fields_control = new Set([
  'controlPerformer',
  'controlStatus',
  'owner',
  'reasonForControlStatus',
  'monitoringlevel'
]);

export const base_fields_control_test_design = new Set([
  'controlName',
  'controlDescription'
]);

export const instance_fields_control_test_design = new Set([
  'testDescription',
  'testingMethod',
  'testObjectiveness',
  'performerToD',
  'approvers',
  'designEffectiveness',
  'evidenceDescription',
  'evidenceFile1',
  'evidenceFile2',
  'lastTestDateDesign'
]);

export const base_fields_control_test_operational = new Set([
  'controlName',
  'controlDescription',
  'controlObjective',
  'testingMethod',
  'testType'
]);

export const instance_fields_control_test_operational = new Set([
  'performerToE',
  'operatingEffectiveness',
  'testDescription',
  'lastTestDateOperational',
  'nextTestDate',
  'evidenceDescription',
  'evidenceType',
  'testResult',
  'reasonForControlStatus',
  'testObjectiveness'
]);

export const riskCategoryOptions = [
  { value: 'Strategic', label: 'Strategic' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Operational', label: 'Operational' },
  { value: 'Legal / Regulatory', label: 'Legal / Regulatory' },
  { value: 'Technology / IT', label: 'Technology / IT' },
  { value: 'Reputational', label: 'Reputational' },
  { value: 'Environmental / ESG', label: 'Environmental / ESG' },
  { value: 'Health & Safety', label: 'Health & Safety' },
  { value: 'Project / Change', label: 'Project / Change' },
  { value: 'Reporting', label: 'Reporting' },
  { value: 'Compliance', label: 'Compliance' }
];

export const base_fields_control_test_attestation = new Set([
  'controlName',
  'controlDescription',
  'start_date',
  'end_date',
  'testingMethod',
  'testType'
]);

export const instance_fields_control_test_attesta = new Set([
  'performer_toe',
  'approver',
  'next_test_date',
  'test_objectiveness_3',
  'test_description_3',
  'evidence_description_3',
  'evidence_file_1',
  'testResult',
  'evidenceType',
  'controlAttestationEffectiveness',
  'testStatus',
  'control_effectiveness'
]);
